import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_WHATSAPP_TEMPLATE, GET_WHATSAPP_TEMPLATE_SUCCESS, GET_WHATSAPP_TEMPLATE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getWhatsAppTemplate({ payload }) {
  
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/message-templates/whatsapp_manual_reply`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_WHATSAPP_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_WHATSAPP_TEMPLATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_WHATSAPP_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchGetWhatsAppTemplate() {
  yield takeEvery(GET_WHATSAPP_TEMPLATE, getWhatsAppTemplate);
}

function* getWhatsAppTemplateSaga() {
  yield all([fork(watchGetWhatsAppTemplate)]);
}

export default getWhatsAppTemplateSaga;
